import { render } from "./SigninForm.vue?vue&type=template&id=40b80381&scoped=true"
import script from "./SigninForm.vue?vue&type=script&lang=js"
export * from "./SigninForm.vue?vue&type=script&lang=js"

import "./SigninForm.vue?vue&type=style&index=0&id=40b80381&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b80381"]])

export default __exports__